// TODO: 実値からtypeを作る
export type OtaType =
    | "Airbnb"
    | "AirbnbMonthly"
    | "Booking.com"
    | "Manual"
    | "Beds24"
    | "Sumyca"
    | "SumycaBookingEngine"
    | "SumycaStay"
    | "Marriott"
    | "AsiaYo"
    | "楽天Travel"
    | "じゃらんnet"
    | "Agoda"
    | "Ctrip"
    | "Expedia"

export const otaTypes: OtaType[] = [
    "Airbnb",
    "AirbnbMonthly",
    "Booking.com",
    "Manual",
    "Beds24",
    "Sumyca",
    "SumycaBookingEngine",
    "SumycaStay",
    "Marriott",
    "AsiaYo",
    "楽天Travel",
    "じゃらんnet",
    "Agoda",
    "Ctrip",
    "Expedia"
]

export const displayOtaType = (
    otaType: OtaType | undefined
): string | undefined => {
    if (!otaType) {
        return undefined
    }

    switch (otaType) {
        case "Manual":
            return "手動予約"
        case "SumycaBookingEngine":
            return "Sumyca予約エンジン"
        case "SumycaStay":
            return "Sumyca Stay"
        default:
            return otaType
    }
}

export const displayOtaInfo = (info: OtaInfo): string => {
    switch (info.otaType) {
        case "Manual":
            return `手動予約${
                info.otaManualType ? `(${info.otaManualType})` : ""
            }`
        default:
            return displayOtaType(info.otaType) ?? info.otaType
    }
}

// coreは検索キーの意味を持たないので、OTAごとの表示名は画面側で値の形から推定する
export const displaySearchKeyLabel = (
    otaType: OtaType | undefined,
    key: string
): string => {
    if (otaType === "Expedia") {
        if (/^\d{10}$/.test(key)) {
            return "Expedia予約番号"
        }
        if (/^\d{14}$/.test(key)) {
            return "Expedia旅程番号"
        }
    }
    return "その他の検索キー"
}

export interface OtaInfo {
    otaId: string
    otaType: OtaType
    otaManualType: string
    secondaryOta?: OtaType
}

export interface ListingOtaInfo {
    otaId: string
    otaType: OtaType
}
